import DomainManager from '../../shared/utils/DomainManager';

export const getSupportLink = (pathName: string, targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);

  return `${domainManager.getSupportDomain()}${pathName}`;
};
